import * as React from "react";
import { LocalCacheHelper } from "../../helpers/LocalCacheHelper";
import { Image, IImageProps } from "@fluentui/react/lib/components/Image";
import AppVersionInfo from "../AppVersionInfo/AppVersionInfo";
import AppFeedback from "../AppFeedback/AppFeedback";
import { Link } from "@fluentui/react/lib/components/Link/Link";
import { ActionButton } from "@fluentui/react/lib/components/Button/ActionButton/ActionButton";

class AppInfo extends React.Component {
    private imageProps: Partial<IImageProps> = {
        src: "/assets/logo-corner-big.svg"
    };

    private imagePropsMobile: Partial<IImageProps> = {
        src: "/assets/logo-corner-small.svg"
    };

    /* eslint-disable */
    constructor(props) {
        super(props);
    }
    /* eslint-enable */

    state = {
        envName: "",
        envProxyUrl: "",
        envReactVersion: "",
        envTeamsAppVersion: "",
        appBuildAtDatetime: "",
        M365UserObjectId: "",
        UseAppInTeamsClient: false,
        CbpxUserImpIdFromProfileMe: "",
        CbpxUserNameAsString: "",
        CbpxUserNumberAsString: "",
        CbpxUserGroupIDAsString: "",
        CpbxUserType: "",
        DataPrivStateLastUpdatedUser: "",
        DataPrivStateLastUpdatedAdmin: "",
        UpdateInfoLastUpdatedAdmin: "",
        UpdateInfoLastUpdatedUser: "",
        UpdateInfoNumberOfDays: ""
    }

    componentDidMount() {
        console.log("start componentDidMount");

        // quick and dirty (expect that the browser-cache will be filled correctly - which is not filled correctly until the user is logged in to cpbx)
        this.setState({
            envName: LocalCacheHelper.GetLocalStorageItemCbpxEnvName(),
            envProxyUrl: LocalCacheHelper.GetLocalStorageItemCbpxProxyUrl(),
            envReactVersion: process.env.APPVERSION ?? "undefined",
            envTeamsAppVersion: process.env.MICROSOFT_APP_VERSION ?? "undefined",
            appBuildAtDatetime: process.env.APPBUILDATETIME ?? "undefined",
            M365UserObjectId: LocalCacheHelper.GetLocalStorageItemM365UserObjectId(),
            UseAppInTeamsClient: (this.state.M365UserObjectId !== "11111111-1111-1111-1111-111111111111"),
            CbpxUserImpIdFromProfileMe: LocalCacheHelper.GetLocalStorageItemCbpxUserImpIdFromProfileMe(),
            CbpxUserNameAsString: LocalCacheHelper.GetLocalStorageItemCbpxUserNameAsString(),
            CbpxUserNumberAsString: LocalCacheHelper.GetLocalStorageItemCbpxUserNumberFromProfileMe(),
            CbpxUserGroupIDAsString: LocalCacheHelper.GetLocalStorageItemCbpxUserGroupIdFromProfileMe(),
            CpbxUserType: LocalCacheHelper.GetLocalStorageItemCpbxUserType(),
            DataPrivStateLastUpdatedUser: LocalCacheHelper.GetLocalStorageItemDataPrivStateLastUpdated(),
            DataPrivStateLastUpdatedAdmin: process.env.APP_DATA_PRIVACY_STATEMENT_LAST_UPDATED_ISO8601 ?? "",
            UpdateInfoLastUpdatedAdmin: process.env.APP_SOFTWARE_LAST_UPDATED_ISO8601 ?? "",
            UpdateInfoLastUpdatedUser: LocalCacheHelper.GetLocalStorageItemVersionSoftwareLastUpdated(),
            UpdateInfoNumberOfDays: process.env.APP_SOFTWARE_LAST_UPDATED_SHOW_IN_DAYS ?? "0"
        });
    }

    componentWillUnmount() {
        console.log("start componentWillUnmount");
    }

    private onClickMakeCookieAndLocalStorageEntriesEmpty = (): void => {
        console.log("onClickMakeCookieEntriesEmpty");
        LocalCacheHelper.RemoveLocalCacheKeysForCbpxLogin();
        localStorage.clear();
        window.location.reload();
    };

    private onClickGoBack = (): void => {
        console.log("onClickGoBack");
        history.back();
    };

    render() {
        return (
            <div>
                <div className="cpbxContOuter ms-Grid">
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl4 ms-xxl6 ms-xlPush8 ms-xxlPush6 cpbxContInner cpbxContInnerLogo">
                            <div className="cpbxBgLogoCont">
                                <Image className="cpbxBgLogo" {...this.imageProps} alt="TelekomLogo" />
                            </div>
                            <div className="cpbxBgLogoCont"><Image className="cpbxBgLogoMobile" {...this.imagePropsMobile} alt="TelekomLogo" /></div>
                        </div>
                        <div className="ms-Grid-col ms-md12 ms-lg12 ms-xl8 ms-xxl6 ms-xlPull4 ms-xxlPull6 cpbxContInner cpbxAppInfo">
                            <div>
                                <h1 className="appInfo">App-Info</h1>
                                <table>
                                    <tr>
                                        <td>Umgebung:</td>
                                        <td>{this.state.envName}</td>
                                    </tr>
                                    <tr>
                                        <td>Proxy-Url:</td>
                                        <td><Link href={this.state.envProxyUrl}>{this.state.envProxyUrl}</Link></td>
                                    </tr>
                                    <tr>
                                        <td>React-Version:</td>
                                        <td>{this.state.envReactVersion}</td>
                                    </tr>
                                    <tr>
                                        <td>Teams-App-Version:</td>
                                        <td>{this.state.envTeamsAppVersion}</td>
                                    </tr>
                                    <tr>
                                        <td>Build-Datum (UTC):</td>
                                        <td>{this.state.appBuildAtDatetime}</td>
                                    </tr>
                                    <tr>
                                        <td>M365UserObjectId:</td>
                                        <td>{this.state.M365UserObjectId}</td>
                                    </tr>
                                    <tr>
                                        <td>UseAppInTeamsClient:</td>
                                        <td>{this.state.UseAppInTeamsClient}</td>
                                    </tr>
                                    <tr>
                                        <td>CbpxUserImpIdFromProfileMe:</td>
                                        <td>{this.state.CbpxUserImpIdFromProfileMe}</td>
                                    </tr>
                                    <tr>
                                        <td>CbpxUserNameAsString:</td>
                                        <td>{this.state.CbpxUserNameAsString}</td>
                                    </tr>
                                    <tr>
                                        <td>CbpxUserNumberAsString:</td>
                                        <td>{this.state.CbpxUserNumberAsString}</td>
                                    </tr>
                                    <tr>
                                        <td>CbpxUserGroupIDAsString:</td>
                                        <td>{this.state.CbpxUserGroupIDAsString}</td>
                                    </tr>
                                    <tr>
                                        <td>CpbxUserType:</td>
                                        <td>{this.state.CpbxUserType}</td>
                                    </tr>
                                    <tr>
                                        <td>DataPrivStateLastUpdatedAdmin:</td>
                                        <td>{this.state.DataPrivStateLastUpdatedAdmin}</td>
                                    </tr>
                                    <tr>
                                        <td>DataPrivStateLastUpdatedUser:</td>
                                        <td>{this.state.DataPrivStateLastUpdatedUser}</td>
                                    </tr>
                                    <tr>
                                        <td>UpdateInfoLastUpdatedAdmin:</td>
                                        <td>{this.state.UpdateInfoLastUpdatedAdmin}</td>
                                    </tr>
                                    <tr>
                                        <td>UpdateInfoLastUpdatedUser:</td>
                                        <td>{this.state.UpdateInfoLastUpdatedUser}</td>
                                    </tr>
                                    <tr>
                                        <td>UpdateInfoNumberOfDays:</td>
                                        <td>{this.state.UpdateInfoNumberOfDays}</td>
                                    </tr>
                                    <tr>
                                        <td>Auflösung (inner):</td>
                                        <td>{window.innerWidth} x {window.innerHeight}</td>
                                    </tr>
                                    <tr>
                                        <td>Auflösung (outer):</td>
                                        <td>{window.outerWidth} x {window.outerHeight}</td>
                                    </tr>
                                </table>
                                <ActionButton className="cookieEntriesEmpty"
                                    onClick={this.onClickMakeCookieAndLocalStorageEntriesEmpty}
                                    allowDisabledFocus
                                    title="Cookie-Einträge und Einträge im lokalen BrowserCache (LocalStorage) entfernen."

                                >
                                    {"Cookies (" + document.cookie.split(";").length + ")" + " und LocalStorage leeren " + "(" + localStorage.length + ")"}
                                </ActionButton>
                                <br />
                                <ActionButton className="back"
                                    onClick={this.onClickGoBack}
                                    allowDisabledFocus
                                >
                                    zurück
                                </ActionButton>
                            </div>
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-md12 ms-lg12 ms-xl12 ms-xxl12 cpbxContInner cpbxFooter">
                            <div>
                                <AppVersionInfo />
                            </div>
                            <div className="cpbxFeedbackLink"><AppFeedback /></div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default AppInfo;
